/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useEffect, useState } from 'react';
import { View, StyleSheet, TouchableOpacity, ScrollView } from 'react-native';

import { Loader } from '@components/screen/Layout';
import ModalFull from '@components/modal/ModalFull';
import SociollaText from '@components/sociolla/SociollaText';
import SelectBox from '@components/form/SelectBox';
import BranchSearch from '@components/form/search/BranchSearch';
import SalesTeamSearch from '@components/form/search/SalesTeamSearch';
import CustomerClusterSearch from '@components/form/search/CustomerClusterSearch';
import BusinessChart from '@/screens/home/components/chart/BusinessChart';

import Colors from '@global/colors';
import { FILTER_YEARS, FILTER_CHANNELS } from '@/constants';
import { prettyNumber } from '@/global/helpers';

function MobileSalesByChart(props) {
  const {
    show = false,
    type = 'branch',
    tabs = [],
    data = [],
    dataMonth = {},
    filter = '',
    filterYear = '',
    filterChannel = '',
    loading = false,
    onChangeYear = () => {},
    onChangeChannel = () => {},
    onChangeFilter = () => {},
    onChangeType = () => {},
    onClose = () => {},
  } = props;

  const [tabActive, setTabActive] = useState(tabs?.length ? tabs[0].value : '');

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (type) {
        setTabActive(type);
      }
    }
    return () => {
      mounted = false;
    };
  }, [type]);

  return (
    <ModalFull show={show} back title="Sales By" onClose={onClose}>
      {tabs?.length ? (
        <ScrollView showsVerticalScrollIndicator={false}>
          <View style={styles.tabs}>
            {tabs.map((item, idx) => (
              <TouchableOpacity
                activeOpacity={0.8}
                style={[
                  styles.tabItem,
                  tabActive == item.value ? styles.tabItemActive : {},
                ]}
                onPress={() => {
                  onChangeType(item.value);
                }}
                key={idx}>
                <SociollaText
                  style={[
                    styles.tabItemText,
                    tabActive == item.value ? styles.tabItemTextActive : {},
                  ]}>
                  {item.label}
                </SociollaText>
              </TouchableOpacity>
            ))}
          </View>
          <View
            style={[
              styles.filterChartWrapper,
              styles.filterChartWrapperPadding,
            ]}>
            <View style={styles.branchFilterMobile}>
              {tabActive == 'branch' ? (
                <BranchSearch
                  value={filter}
                  hideLabel
                  arrayOne
                  customFilter={{ is_active: true }}
                  onChange={(value) => {
                    onChangeFilter(value);
                  }}
                />
              ) : tabActive == 'salesteam' ? (
                <SalesTeamSearch
                  value={filter}
                  hideLabel
                  onChange={(value) => {
                    onChangeFilter(value);
                  }}
                />
              ) : tabActive == 'cluster' ? (
                <CustomerClusterSearch
                  label="Cluster"
                  value={filter}
                  onChange={(value) => {
                    onChangeFilter(value);
                  }}
                />
              ) : tabActive == 'channel' ? (
                <SelectBox
                  label="Channel"
                  options={FILTER_CHANNELS}
                  value={filterChannel}
                  placeholder="Select Channel"
                  trackBy="value"
                  labelKey="label"
                  onChange={(value) => {
                    onChangeChannel(value);
                  }}
                />
              ) : (
                false
              )}
            </View>
          </View>
          <View style={styles.filterChartWrapper}>
            <View style={styles.filterChartItem}>
              <SociollaText style={styles.filterLabel}>Sales Year</SociollaText>
              <SelectBox
                label="Sales Year"
                hideLabel
                options={FILTER_YEARS}
                value={filterYear}
                placeholder="Select Sales Year"
                trackBy="value"
                labelKey="label"
                style={styles.filterInput}
                onChange={(value) => {
                  onChangeYear(value);
                }}
              />
            </View>
            <View style={styles.filterChartItem}>
              <SociollaText style={styles.filterLabel}>
                Compare with
              </SociollaText>
              <SelectBox
                label="Compare with"
                hideLabel
                options={FILTER_YEARS}
                value={{}}
                placeholder="-"
                trackBy="value"
                labelKey="label"
                style={styles.filterInput}
                onChange={(value) => {
                  console.log('sales-year', value);
                }}
              />
            </View>
          </View>
          {data?.length && !loading ? (
            <View style={styles.boxTotal}>
              <View style={styles.boxTotalItem}>
                <SociollaText type="bold" style={styles.boxTotalTitle}>
                  {dataMonth?.name || '-'}
                </SociollaText>
                <View style={styles.boxTotalCompare}>
                  <View style={styles.boxCompareItem}>
                    <View style={styles.labelCat}>
                      <View style={styles.labelCatRow}>
                        <View style={styles.labelCatChild}>
                          <View
                            style={[
                              styles.labelCatBox,
                              { backgroundColor: Colors.green0 },
                            ]}
                          />
                          <SociollaText
                            type="medium"
                            style={styles.labelCatText}>
                            Gross
                          </SociollaText>
                        </View>
                        <SociollaText type="medium" style={styles.labelCatText}>
                          {' '}
                          : {prettyNumber(dataMonth?.gross || 0)}
                        </SociollaText>
                      </View>

                      <View style={styles.labelCatRow}>
                        <View style={styles.labelCatChild}>
                          <View
                            style={[
                              styles.labelCatBox,
                              { backgroundColor: Colors.yellow0 },
                            ]}
                          />
                          <SociollaText
                            type="medium"
                            style={styles.labelCatText}>
                            Valid
                          </SociollaText>
                        </View>
                        <SociollaText type="medium" style={styles.labelCatText}>
                          {' '}
                          : {prettyNumber(dataMonth?.valid || 0)}
                        </SociollaText>
                      </View>

                      <View style={styles.labelCatRow}>
                        <View style={styles.labelCatChild}>
                          <View
                            style={[
                              styles.labelCatBox,
                              { backgroundColor: Colors.blue4 },
                            ]}
                          />
                          <SociollaText
                            type="medium"
                            style={styles.labelCatText}>
                            Nett
                          </SociollaText>
                        </View>
                        <SociollaText type="medium" style={styles.labelCatText}>
                          {' '}
                          : {prettyNumber(dataMonth?.nett || 0)}
                        </SociollaText>
                      </View>

                      {data?.length > 3 ? (
                        <View style={styles.labelCatRow}>
                          <View style={styles.labelCatChild}>
                            <View
                              style={[
                                styles.labelCatBox,
                                { backgroundColor: Colors.purple0 },
                              ]}
                            />
                            <SociollaText
                              type="medium"
                              style={styles.labelCatText}>
                              Target
                            </SociollaText>
                          </View>
                          <SociollaText
                            type="medium"
                            style={styles.labelCatText}>
                            {' '}
                            : {prettyNumber(dataMonth?.target || 0)}
                          </SociollaText>
                        </View>
                      ) : (
                        false
                      )}
                    </View>
                  </View>
                  <View style={styles.boxCompareTargetItem}>
                    <SociollaText type="medium" style={styles.targetText}>
                      {dataMonth?.percentage_gross || 0}%
                    </SociollaText>
                    <SociollaText type="medium" style={styles.targetText}>
                      {dataMonth?.percentage_valid || 0}%
                    </SociollaText>
                    <SociollaText type="medium" style={styles.targetText}>
                      {dataMonth?.percentage_nett || 0}%
                    </SociollaText>
                  </View>
                </View>
              </View>
            </View>
          ) : (
            false
          )}
          {loading ? (
            <View style={styles.loader}>
              <Loader />
            </View>
          ) : data?.length ? (
            <ScrollView horizontal showsHorizontalScrollIndicator={false}>
              <View style={styles.chartWrapper}>
                <BusinessChart
                  data={data}
                  hideCategory
                  colors={[
                    Colors.green0,
                    Colors.yellow0,
                    Colors.blue4,
                    Colors.purple0,
                  ]}
                />
              </View>
            </ScrollView>
          ) : (
            <View style={styles.loader}>
              <SociollaText>
                No data found. Please use another filter!
              </SociollaText>
            </View>
          )}
          {data?.length && !loading ? (
            <View style={styles.chartLabelCat}>
              <View style={styles.chartLabelCatChild}>
                <View
                  style={[
                    styles.chartLabelCatBox,
                    { backgroundColor: Colors.green0 },
                  ]}
                />
                <SociollaText type="medium" style={styles.chartLabelCatText}>
                  Gross
                </SociollaText>
              </View>

              <View style={styles.chartLabelCatChild}>
                <View
                  style={[
                    styles.chartLabelCatBox,
                    { backgroundColor: Colors.yellow0 },
                  ]}
                />
                <SociollaText type="medium" style={styles.chartLabelCatText}>
                  Valid
                </SociollaText>
              </View>

              <View style={styles.chartLabelCatChild}>
                <View
                  style={[
                    styles.chartLabelCatBox,
                    { backgroundColor: Colors.blue4 },
                  ]}
                />
                <SociollaText type="medium" style={styles.chartLabelCatText}>
                  Nett
                </SociollaText>
              </View>

              {data?.length > 3 ? (
                <View style={styles.chartLabelCatChild}>
                  <View
                    style={[
                      styles.chartLabelCatBox,
                      { backgroundColor: Colors.purple0 },
                    ]}
                  />
                  <SociollaText type="medium" style={styles.chartLabelCatText}>
                    Target
                  </SociollaText>
                </View>
              ) : (
                false
              )}
            </View>
          ) : (
            false
          )}
        </ScrollView>
      ) : (
        false
      )}
    </ModalFull>
  );
}

const styles = StyleSheet.create({
  tabs: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottomColor: Colors.grey0,
    borderBottomWidth: 2,
  },
  tabItem: {
    // width: '25%',
    padding: 13,
    textAlign: 'center',
    marginBottom: -2,
    borderBottomColor: Colors.grey0,
    borderBottomWidth: 2,
  },
  tabItemActive: {
    borderBottomColor: Colors.blue0,
  },
  tabItemText: {
    color: Colors.grey1,
  },
  tabItemTextActive: {
    color: Colors.black0,
  },
  filterChartWrapper: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginVertical: 10,
    zIndex: 1,
    elevation: 1,
  },
  filterChartWrapperPadding: {
    paddingHorizontal: 10,
    marginBottom: 0,
  },
  filterChartItem: { padding: 10, width: '50%' },
  filterLabel: { fontSize: 12, color: Colors.grey1, marginBottom: 5 },
  filterInput: { width: '100%' },
  boxTotal: {
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  boxTotalItem: {
    width: '100%',
    maxWidth: 215,
    padding: 15,
    borderRadius: 5,
    borderWidth: 1,
    borderColor: Colors.grey0,
  },
  boxTotalTitle: {
    fontSize: 14,
    color: Colors.black0,
  },
  boxTotalCompare: {
    width: '100%',
    flexDirection: 'row',
    marginTop: 10,
  },
  boxCompareItem: {
    width: '70%',
  },
  boxCompareTargetItem: {
    width: '30%',
    marginTop: -2,
  },
  targetText: {
    fontSize: 15,
    color: Colors.green1,
    marginBottom: 7,
  },
  labelCat: {
    justifyContent: 'flex-start',
  },
  labelCatRow: { flexDirection: 'row', alignItems: 'center', marginBottom: 10 },
  labelCatChild: { flexDirection: 'row' },
  labelCatBox: { width: 14, height: 14, marginRight: 10 },
  labelCatText: { fontSize: 12 },
  chartWrapper: {
    width: 800,
    paddingLeft: 15,
    marginTop: 15,
    // marginHorizontal: -40,
    // marginBottom: -10,
    // marginTop: -35,
  },
  chartLabelCat: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 50,
  },
  chartLabelCatChild: { marginHorizontal: 10, flexDirection: 'row' },
  chartLabelCatBox: { width: 12, height: 12, marginRight: 10 },
  chartLabelCatText: { fontSize: 10 },
  branchFilterMobile: { width: '100%' },
  loader: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
});

export default React.memo(MobileSalesByChart, (prev, next) => prev == next);
